import { productFruits } from "product-fruits";
import { zitadelAuth } from "@/services/authService";
import i18n from "@/plugins/i18n";
import { isProduction, isStaging } from "@/utils/env.js";

const initializeProductFruits = () => {
  window.productFruits?.services?.destroy();

  const workspaceCode = window.runtimeConfig?.PRODUCT_FRUITS_WORKSPACE_CODE;

  // Check if workspace code is valid (not a template variable)
  if (!workspaceCode || workspaceCode.startsWith("$")) {
    console.warn(
      "Product Fruits workspace code not configured or is a template variable:",
      workspaceCode
    );
    return;
  }

  const user = zitadelAuth.oidcAuth?.user;
  const isAuthenticated = zitadelAuth.oidcAuth?.isAuthenticated;

  if (!isAuthenticated || !user?.profile) {
    return;
  }

  const userInfo = {
    firstName:
      user.profile?.given_name || user.profile?.name?.split(" ")[0] || "null",
    lastName:
      user.profile?.family_name || user.profile?.name?.split(" ")[1] || "null",
    role: user.profile?.role || "user",
    username: user.profile?.name || user.profile?.preferred_username || "null",
    props: {
      email: user.profile?.email,
      locale: user.profile?.locale,
      environment: isProduction
        ? "production"
        : isStaging
        ? "staging"
        : "local",
      userID: user.profile?.sub || "null",
      app: "fast-fusion-solar",
    },
  };

  if (userInfo.props.userID !== "null") {
    productFruits.init(workspaceCode, i18n.global.locale.value, userInfo);
  }
};

export { initializeProductFruits };
